import { getEvaluate } from "@lib/loaders/mathjsLoader";

export function cleanExpression(expression: string): string {
    if (expression.startsWith("=")) {
        return expression.substring(1).trim();
    }
    return expression.trim();
}

export async function getResultOfExpression(
    expression: string,
): Promise<number> {
    const evaluate = await getEvaluate();
    const result = evaluate(expression);

    if (isNaN(result)) {
        throw new Error("Expression evaluation failed");
    }

    return Math.round(result * 100) / 100;
}
